import Vue from 'vue'


export const EVENTS = {
  UnauthenticatedRequest: 'UnauthenticatedRequest',
  OpenChat: 'OpenChat',
  OpenModal: 'OpenModal',
  OpenWayfinder: 'OpenWayfinder'
}
export const EventBus = new Vue()
